import SegmentedChartsReports from '@/pages/reports/SegmentedChartsReports'
import SegmentedTextualReports from '@/pages/reports/SegmentedTextualReports'
import QuizReports from '@/pages/reports/QuizReports'
import RelatorioEstatistico from '@/pages/reports/RelatorioEstatistico'

const routes = [
  {
    path: '/relatorio-estatistico',
    name: 'RelatorioEstatistico',
    component: RelatorioEstatistico,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_RESEARCHER'],
      researcherOnly: true
    }
  },
  {
    path: '/segmented-charts-reports',
    name: 'SegmentedChartsReports',
    component: SegmentedChartsReports,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_PARTNER', 'ROLE_ADMIN']
    }
  },
  {
    path: '/segmented-textual-reports',
    name: 'SegmentedTextualReports',
    component: SegmentedTextualReports,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_PARTNER', 'ROLE_ADMIN']
    }
  },
  {
    path: '/quiz-reports',
    name: 'QuizReports',
    component: QuizReports,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_PARK', 'ROLE_PARTNER']
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/reports.js